export const EMAIL_REGEX = /\S+@\S+\.\S+/;

export const loginValidationSchema = {
  email: {
    required: true,
    pattern: EMAIL_REGEX,
    message: 'Please enter a valid email address'
  },
  password: {
    required: true,
    message: 'Password is required'
  }
};
